module.exports = __webpack_public_path__ + "img/3.098d7536.jpg";